import dataLayerSearch from 'assets/core/js/module/searchForm/dataLayer/search'
import SelectManager, { type Select } from 'assets/core/js/module/selectManager'
import autocomplete from 'assets/themes/campings/js/module/searchForm/autocomplete'
import calendar from 'assets/themes/campings/js/module/searchForm/calendar'
import events from 'assets/themes/campings/js/module/searchForm/events'
import maxDistance from 'assets/themes/campings/js/module/searchForm/maxDistance'
import menus from 'assets/themes/campings/js/module/searchForm/menus'
import travelerSelector from 'assets/themes/campings/js/module/searchForm/travelerSelector'

export default function (): void {
  const calendarInstance = calendar()
  const autocompleteInstance = autocomplete()
  events()
  menus()
  maxDistance()
  const travelerSelectorInstance = travelerSelector()
  let capacityInstance: Select | undefined
  // When the traveler selector is enabled, the capacity is not a select.
  if (!travelerSelectorInstance) {
    capacityInstance = SelectManager.getSelect('search_offers_capacity')
  }

  dataLayerSearch(autocompleteInstance, calendarInstance, travelerSelectorInstance, capacityInstance)
}
